/**
 * VIP Club V4 — Value Calculator
 * Namespace: vc4__
 * Modeled after proven buy-box-v4.js add-to-cart pattern
 */
(function() {
  'use strict';

  console.log('VC4: Script loaded');

  function init() {
    var containers = document.querySelectorAll('.vc4');
    console.log('VC4: Found ' + containers.length + ' container(s)');
    containers.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section) {
      var boxes = section.querySelectorAll('.vc4');
      if (boxes.length > 0) boxes.forEach(initSection);
    }
  });

  function initSection(container) {
    if (container._vc4Init) return;
    container._vc4Init = true;

    var fee    = parseFloat(container.dataset.fee) || 30;
    var credit = parseFloat(container.dataset.credit) || 40;
    var rawVid = container.dataset.vid || '';
    var rawSp  = container.dataset.sp || '';
    var qty    = 1;

    console.log('VC4: initSection — rawVid="' + rawVid + '", rawSp="' + rawSp + '"');

    initGallery(container);
    initReviewScroll(container);

    /* ---- Expand toggle ---- */
    var togBtn  = container.querySelector('.vc4__expand-btn');
    var togBody = container.querySelector('.vc4__expand-body');
    if (togBtn && togBody) {
      togBtn.addEventListener('click', function() {
        var open = togBtn.getAttribute('aria-expanded') === 'true';
        togBtn.setAttribute('aria-expanded', String(!open));
        if (open) {
          togBody.classList.remove('vc4__expand-body--open');
        } else {
          togBody.classList.add('vc4__expand-body--open');
        }
      });
    }

    /* ---- Qty buttons ---- */
    var qBtns = container.querySelectorAll('.vc4__qty');
    qBtns.forEach(function(b) {
      b.addEventListener('click', function() {
        qty = parseInt(this.dataset.q, 10) || 1;
        qBtns.forEach(function(x) { x.classList.remove('vc4__qty--active'); });
        this.classList.add('vc4__qty--active');
        updateCalc();
      });
    });

    /* ---- Math calc ---- */
    var mathBox  = container.querySelector('.vc4__math');
    var elPay    = container.querySelector('[data-calc="pay"]');
    var elGet    = container.querySelector('[data-calc="get"]');
    var elProfit = container.querySelector('[data-calc="profit"]');
    var cta2     = container.querySelector('.vc4__cta2');

    function updateCalc() {
      var p  = fee * qty;
      var g  = credit * qty;
      var pr = g - p;
      if (elPay)    elPay.textContent    = '$' + p + '/month';
      if (elGet)    elGet.textContent    = '$' + g + ' in credits';
      if (elProfit) elProfit.textContent = '+$' + pr + '/month';
      if (mathBox)  mathBox.hidden = (qty <= 1);
      if (cta2) {
        cta2.hidden = (qty <= 1);
        cta2.textContent = 'Get ' + qty + ' Memberships \u2014 $' + p + '/month';
      }
    }

    /* ---- Clean IDs (same pattern as all other sections) ---- */
    var variantId = rawVid ? rawVid.replace(/\D/g, '') : '';
    var sellingPlanId = rawSp ? rawSp.replace(/\D/g, '') : '';

    console.log('VC4: Cleaned variantId="' + variantId + '", sellingPlanId="' + sellingPlanId + '"');

    /* ---- CTA click (NO designMode guard — matches buy-box-v4.js) ---- */
    var ctaMain = container.querySelector('.vc4__cta');
    console.log('VC4: CTA button found:', !!ctaMain);

    if (ctaMain) {
      ctaMain.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('VC4: CTA clicked, variantId="' + variantId + '"');
        if (variantId) {
          if (sellingPlanId) {
            addToCart(variantId, 1, sellingPlanId);
          } else {
            addToCart(variantId, 1, null);
          }
        } else {
          console.error('VC4: No variant ID found — check your section settings');
          alert('Error: No variant ID configured. Please add one in the section settings.');
        }
      });
    }

    if (cta2) {
      cta2.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('VC4: CTA2 clicked, qty=' + qty);
        if (variantId) {
          if (sellingPlanId) {
            addToCart(variantId, qty, sellingPlanId);
          } else {
            addToCart(variantId, qty, null);
          }
        } else {
          console.error('VC4: No variant ID found');
          alert('Error: No variant ID configured.');
        }
      });
    }

    updateCalc();
  }

  /* ========== Gallery ========== */
  function initGallery(container) {
    var gallery = container.querySelector('.vc4__gallery');
    if (!gallery) return;

    var images     = gallery.querySelectorAll('.vc4__img');
    var thumbnails = gallery.querySelectorAll('.vc4__thumb');
    var prevBtn    = gallery.querySelector('.vc4__arrow--prev');
    var nextBtn    = gallery.querySelector('.vc4__arrow--next');
    var counter    = gallery.querySelector('.vc4__counter-current');

    if (images.length === 0) return;
    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      images.forEach(function(img, i) {
        img.classList.toggle('vc4__img--active', i === currentIndex);
      });
      thumbnails.forEach(function(thumb, i) {
        thumb.classList.toggle('vc4__thumb--active', i === currentIndex);
      });
      if (counter) counter.textContent = currentIndex + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex + 1); });

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        showImage(parseInt(this.dataset.index, 10));
      });
    });

    /* Touch swipe */
    var touchStartX = 0;
    var galleryMain = gallery.querySelector('.vc4__main-img');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1);
        }
      }, { passive: true });
    }
  }

  /* ========== Review Scroll ========== */
  function initReviewScroll(container) {
    var btn = container.querySelector('.vc4__social');
    if (!btn) return;
    var id = btn.dataset.reviewsId;
    if (!id) return;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ========== Add to Cart (exact same pattern as buy-box-v4.js) ========== */
  function addToCart(variantId, quantity, sellingPlanId) {
    var item = { id: parseInt(variantId, 10), quantity: quantity };
    if (sellingPlanId) item.selling_plan = parseInt(sellingPlanId, 10);

    console.log('VC4: Adding to cart', JSON.stringify(item));

    var ctaButtons = document.querySelectorAll('.vc4__cta, .vc4__cta2');
    ctaButtons.forEach(function(btn) { btn.disabled = true; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw new Error(err.message || err.description || 'Failed to add to cart'); });
      return response.json();
    })
    .then(function(data) {
      console.log('VC4: Added to cart successfully', data);
      ctaButtons.forEach(function(btn) { btn.disabled = false; });
      openCartDrawer();
    })
    .catch(function(error) {
      console.error('VC4: Error adding to cart', error);
      ctaButtons.forEach(function(btn) { btn.disabled = false; });
      alert('Error: ' + error.message);
    });
  }

  /* ========== Open Cart Drawer (exact same as buy-box-v4.js) ========== */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));

    var cartTriggers = ['[data-cart-trigger]', '.js-cart-trigger', '.cart-icon', '[data-action="open-drawer"][data-drawer="cart"]', '#cart-icon', '.header__icon--cart', '[href="/cart"]'];
    var drawerOpened = false;

    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger && (trigger.hasAttribute('data-cart-trigger') || trigger.hasAttribute('data-action') || trigger.classList.contains('js-cart-trigger'))) {
        trigger.click();
        drawerOpened = true;
        break;
      }
    }

    var drawerSelectors = ['.cart-drawer', '#cart-drawer', '.drawer--cart', '[data-drawer="cart"]', '.mini-cart', '.cart-flyout'];
    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) { drawer.classList.add('is-open', 'active', 'open'); drawerOpened = true; break; }
    }

    if (!drawerOpened) {
      setTimeout(function() {
        var visible = document.querySelector('.cart-drawer.is-open, .drawer--cart.active, [data-drawer="cart"].open');
        if (!visible) window.location.href = '/cart';
      }, 300);
    }
  }

})();
